import React from 'react';
import { Link } from 'react-router-dom';
import { Field } from '../../components/ui';

// A sticker layout is drawn with a mouse, so the phone gets the numbers only:
// pick the sheet, correct the printer's drift, and go to the printing page.
export default function LabelSetupMobile({ vm }) {
  const { tpl, change, setSheet, usePreset, presets, problems, perSheet, printTest } = vm;

  const num = (label, key, step = 0.1) => (
    <label className="field">{label}
      <input type="number" step={step} value={tpl.sheet[key]} onChange={e => setSheet(key, e.target.value)} />
    </label>
  );

  return (
    <div>
      <div className="page-head"><h1>Label setup</h1><span className="muted">{perSheet} per sheet</span></div>

      {problems.map(p => <div key={p} className="card card-pad lbl-problems">⚠ {p}</div>)}

      <div className="card card-pad">
        <Field label="Standard sheet" type="select" value={tpl.preset}
          options={presets.map(p => ({ value: p.key, label: p.label }))} onChange={usePreset} />
        {num('Label width (mm)', 'labelWidth')}
        {num('Label height (mm)', 'labelHeight')}
        {num('Top margin (mm)', 'marginTop')}
        {num('Left margin (mm)', 'marginLeft')}
        {num('Gap across (mm)', 'gapX')}
        {num('Gap down (mm)', 'gapY')}
        {num('Columns', 'columns', 1)}
        {num('Rows', 'rows', 1)}
        <label className="field">Shift right (mm)
          <input type="number" step="0.5" value={tpl.offsetX} onChange={e => change({ offsetX: Number(e.target.value) || 0 })} />
        </label>
        <label className="field">Shift down (mm)
          <input type="number" step="0.5" value={tpl.offsetY} onChange={e => change({ offsetY: Number(e.target.value) || 0 })} />
        </label>
      </div>

      <div className="muted" style={{ fontSize: 12.5, margin: '10px 2px' }}>
        The text on the label is arranged on a computer — open this page there to drag the lines about.
      </div>

      <div style={{ display: 'grid', gap: 8 }}>
        <button className="btn light" style={{ padding: 12 }} onClick={printTest}>Test sheet</button>
        <Link className="btn primary" style={{ padding: 12, textAlign: 'center' }} to="/app/labels">Print labels →</Link>
      </div>
    </div>
  );
}
